<script type="text/jsx">
import ParticipantsDiffPopover from '@/plans/LARGE_MEETING/component/participants-diff-popover.vue';
import planCommonMixin from '@/plans/WEBINAR/mixin';
import PlanDetailsMixin from '@/plans/EVENT_SAAS/component/dialog/plan-details/mx-plan-details';
import ConfigBase from '@/components/config-base';
import { toThousands } from '@/utils/money';

export default {
  name: 'ConfigBase',
  extends: ConfigBase,
  mixins: [planCommonMixin, PlanDetailsMixin],
  components: { ParticipantsDiffPopover },
  data() {
    return {
      orderByKey: "capacity",
    };
  },
  computed: {
    configDesc(){
      return this.$t('billing.webinar.config_desc_new', [toThousands(10000),100])
    }
  },
  methods: {
    mx_renderConfigDesc() {
      return <p class="opc-addon-config__main__title">
        <span>{this.configDesc}</span>
        <participants-diff-popover type={this.planType} />
      </p>;
    },
  },
};
</script>
